<template>
  <v-container>
    <div
      class="
        d-flex
        flex-lg-row flex-column
        justify-lg-space-between
        align-lg-center align-start
        justify-center
      "
    >
      <h1 class="pt-3 pb-5">
        {{
          activeTerminal == ""
            ? "Stickers library"
            : "Stickers Library - " + activeTerminal
        }}
      </h1>
    </div>
    <div>
      <v-list dense>
        <StickerCard
          v-for="(item, index) in stickers"
          :key="index"
          :received="item"
          @openView="openView"
          @receiveStickers="receiveStickers"
          :index="index"
        />
      </v-list>
      <v-card
        height="48px"
        elevation="0"
        rounded="0"
        v-if="stickers.length == 0"
        style="background-color: #efefef;"
      >
        <p class="text-center" style="line-height: 48px;">No data</p>
      </v-card>
      <v-btn
        block
        color="primary"
        class="mt-4"
        @click="stickerDialog = true"
        v-if="activeTerminal"
        >Add new sticker</v-btn
      >
    </div>
    <v-dialog v-if="view" v-model="view" transition="dialog-bottom-transition">
      <v-card>
        <v-container>
          <v-row align="center" justify="center">
            <img style="max-height: 500px; width: auto" :src="image" alt />
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <StickerDialog :dialog="stickerDialog" @close="stickerDialog = false" @resetData="receiveStickers" :terminal="activeTerminal"/>
  </v-container>
</template>

<script>
import StickerCard from "../components/StickerCard.vue";
import StickerDialog from "../components/Stickers/StickerDialog.vue";
import {mapState} from "vuex";

export default {
  name: "Stickers",
  data: () => ({
    stickers: [],
    view: false,
    image: "",
    error: "",
    stickerDialog: false,
  }),
  components: {
    StickerDialog,
    StickerCard,
  },
  computed: {
    ...mapState("terminals", ["activeTerminal"]),
  },
  watch: {
    activeTerminal() {
      if (this.activeTerminal !== "") {
        this.receiveStickers();
      }
    },
  },
  methods: {
    receiveStickers() {
      this.$http.get("rest/stickers/" + this.activeTerminal).then((res) => {
        this.stickers = res.data.stickers;
      });
    },
    openView(sticker) {
      this.view = true;
      this.image = sticker;
    },
  },
  mounted() {
    if (this.activeTerminal !== "") {
      this.receiveStickers();
    }
  },
};
</script>
